var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 10.4961L21.2168 8.41797C21.0701 8.27059 20.8957 8.15366 20.7036 8.07389C20.5115 7.99412 20.3056 7.95308 20.0977 7.95313C19.6738 7.95313 19.2754 8.11914 18.9766 8.41797L16.7383 10.6562C16.5909 10.803 16.474 10.9774 16.3942 11.1694C16.3144 11.3615 16.2734 11.5674 16.2734 11.7754C16.2734 12.1992 16.4395 12.5977 16.7383 12.8965L18.375 14.5332C17.9919 15.3777 17.4592 16.1459 16.8027 16.8008C16.1479 17.4589 15.3797 17.9935 14.5352 18.3789L12.8984 16.7422C12.7517 16.5948 12.5773 16.4779 12.3852 16.3981C12.1932 16.3183 11.9873 16.2773 11.7793 16.2773C11.3555 16.2773 10.957 16.4434 10.6582 16.7422L8.41797 18.9785C8.27041 19.1255 8.15338 19.3002 8.0736 19.4926C7.99383 19.685 7.95288 19.8913 7.95313 20.0996C7.95313 20.5234 8.11914 20.9219 8.41797 21.2207L10.4941 23.2969C10.9707 23.7754 11.6289 24.0469 12.3047 24.0469C12.4473 24.0469 12.584 24.0352 12.7188 24.0117C15.3516 23.5781 17.9629 22.1777 20.0703 20.0723C22.1758 17.9688 23.5742 15.3594 24.0137 12.7188C24.1465 11.9121 23.8789 11.082 23.2969 10.4961Z",
    fill: "#395E9D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#395E9D",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileC);
export default __webpack_public_path__ + "static/media/profileC.4621f2a5a816bacba84d4d5ead0a8fc2.svg";
export { ForwardRef as ReactComponent };